import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)


export default new Vuex.Store({
  state: {
    token: '',
    userInfo: '',
    role: '',//当前角色
    roles:'',//登录账号所具有的角色
    title: '',
    sysPower:'',
  },
  getters: {

  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },

    setUserInfo(state, userInfo) {
      let date = new Date(userInfo.hire_date);
      let year = date.getFullYear();
      let month_int = date.getMonth() + 1;
      let month_string = month_int < 10 ? "0" + month_int : month_int;
      let day = date.getDay() < 10 ? "0" + date.getDay() : date.getDay();
      userInfo.hire_date = year + "-" + month_string + "-" + day;
      state.userInfo = userInfo;
    },

    setRole(state, role) {
      state.role = role
    },

    setRoles(state,roles){
      state.roles = roles;
    },

    setTitle(state, title) {
      state.title = title;
    },

    setSysPower(state, sysPower){
      state.sysPower = sysPower;
    },

    RESET_STATE(state) {
      // 将 state 中的所有属性置为默认值
      state.token = '';
      state.role = ''
      state.roles = '';
      //  state.title = title;
      state.sysPower = '';
      state.userInfo = '';
      // ...
    }
  },
  actions: {
  },
  modules: {
  },
  plugins:[
    createPersistedState()
  ]
})
